export default __webpack_public_path__ + "static/media/spain.1f934d46.svg";